import { ISyncCoreApi } from '@edgebox/sync-core-rest-client';
import React from 'react';
import { HealthCheckNameReference } from './HealthCheckNameReference';
import { resolveHealthCheckScorePresentation } from './HealthCheckScorePresentation';

export function HealthCheckScoreBadge({ api, healthCheckKey, score }: { api?: ISyncCoreApi; healthCheckKey: string; score: number }) {
  const normalizedScore = Math.max(0, Math.min(1, score));
  const scorePercentage = Math.round(normalizedScore * 100);
  const presentation = resolveHealthCheckScorePresentation(scorePercentage);

  return (
    <span
      title={`${scorePercentage}% health score`}
      className="inline-flex max-w-full items-center gap-1.5 rounded-xl px-2.5 py-0.5 text-[0.6875rem] font-semibold leading-5"
      style={presentation.style}
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 shrink-0 rounded-full bg-current opacity-70" />
      <span className="min-w-0 break-words">
        <HealthCheckNameReference api={api} healthCheckKey={healthCheckKey} fallback={healthCheckKey} />
      </span>
      <span className="shrink-0 tabular-nums opacity-70">{scorePercentage}%</span>
    </span>
  );
}
